"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = require("@angular/core");
var CardComponent = (function () {
    function CardComponent() {
    }
    Object.defineProperty(CardComponent.prototype, "depthClass", {
        get: function () {
            return this.depth ? "z-depth-" + this.depth : '';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CardComponent.prototype, "topDepthClass", {
        get: function () {
            return !this.depth && this.topDepth ? "z-depth-" + this.topDepth + "-top" : '';
        },
        enumerable: true,
        configurable: true
    });
    return CardComponent;
}());
__decorate([
    core_1.Input(),
    __metadata("design:type", Number)
], CardComponent.prototype, "depth", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Number)
], CardComponent.prototype, "topDepth", void 0);
CardComponent = __decorate([
    core_1.Component({
        selector: 'card',
        template: "\n      <div class=\"card {{depthClass}} {{topDepthClass}}\"><ng-content></ng-content></div>\n    ",
    }),
    __metadata("design:paramtypes", [])
], CardComponent);
exports.CardComponent = CardComponent;



//////////////////
// WEBPACK FOOTER
// ./~/ng2-material-components/user-interface/card/card.component.js
// module id = 111
// module chunks = 0